@if (hasKpiData()) {
  <p-button
    icon="pi pi-list-check"
    [label]="'pages.transport.tracking-list.manage-kpi-bar' | translate"
    (onClick)="onManageKpiBarClick($event)"
    styleClass="mr--4"
    variant="text"
  />
}

<p-popover #popover>
  <p-listbox
    [filter]="true"
    [checkbox]="true"
    [highlightOnSelect]="false"
    [options]="filteredKpis()"
    [ngModel]="selectedKpis()"
    (ngModelChange)="onSelectionListChange($event)"
    optionLabel="title"
    [multiple]="true"
    [metaKeySelection]="false"
    dataKey="field"
  >
    <ng-template pTemplate="item" let-kpi>
      <div class="manage-kpi-bar__item" pDraggable="kpi" pDroppable="kpi" (onDragStart)="onDragStart(kpi)" (onDrop)="onDrop(kpi)">
        <span class="manage-kpi-bar__label">
          {{ kpi.title ?? kpi.field }}
        </span>
        <i class="pi pi-bars manage-kpi-bar__drag-handle"></i>
      </div>
    </ng-template>
  </p-listbox>
</p-popover>
